<script setup>
import InvitationDataEmail from '@/components/invitation/components/data/InvitationDataEmail.vue';

const props = defineProps({
    status: Number,
    data: Object
});

</script>

<template>
    <div class="invitation-status">
        <div class="form_header">
            {{ $t('route.invitation') }}
        </div>
        <div class="status-content-wrapper">
            <div class="form-description-state">
                <span class="invitation__state">
                    {{ $t(`invitations.states[${props.status}]`) }}
                </span>
            </div>
            <InvitationDataEmail class="email"
            :email="data.invitationEmail"
            />
        </div>
    </div>
</template>

<style lang="scss">
.invitation-status {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    
}
.form_header {
    font-family: "CircularStd-Bold";
    opacity: 0.46;
    text-transform: capitalize;
    margin-bottom: 0.6rem;
}

.status-content-wrapper{
    bottom: 0.5rem;
}
.form-description-state {
    display: flex;
    width: 6rem;
    height: 1rem;
    justify-content: center;
    align-items: center;
    background: #E29700 0% 0% no-repeat padding-box; 
    color: #ffffff;
    border-radius: 11px;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
    

    .invitation__state {
        opacity: 1;
        padding: 0;
        margin: 0;
        top: 1px;
    }
}

@media (max-width: 576px) {
    .invitation-status {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        gap: 0.5rem;
        align-items: center;
        
    }

    .form_header {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        margin-bottom: 0.5rem;
        font-size:22px !important;
    }

    .form-description-state {
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        align-self: center;
        height: 1.4rem;
        
    }

    .status-content-wrapper {
        grid-column: 1 / 3;
        grid-row: 2 / 3;
        margin-top: 0;
    }
}

@media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    
    .form-description-state{
        bottom: 0.4rem;
    }

    .form_header{
        margin-bottom: 1rem !important;
        font-size: 18px;
    }

}

@media (min-width: 1024px) and (max-width: 1400px) and (orientation: landscape) {

    .form-description-state{
        
        bottom: 0.3rem;
        
    }
    .form_header{
        margin-bottom: 1rem !important;
        font-size: 18px;
    }
}

</style>